import React, { useState } from 'react';
import styles from './Button.module.scss';
import Loader from '../../loader/Loader';
import { getSvg } from './factory/getSvg';
import { useBrandingContext } from 'app-context/BrandingsContext';
import { addOpacityToColor } from 'helpers/addOpacityToColor';

// for the variant - pass a hash color #000000 Not a string "black" or the opacity wont work
const Button = ({
  label,
  onClick,
  //fixed color (doesn't change when branding color change)
  variant = null,
  //svg name
  type,
  color,
  opicBackground = false,
  transparent = false,
  width,
  isLoading,
  className,
  buttonType,
  disabled,
  svgClassName,
  id,
  labelClassName,
  ...props
}) => {
  const { brandingData } = useBrandingContext();
  const { page_ButtonColor } = brandingData;
  const [isHover, setIsHovered] = useState(false);
  const buttonClass = `${styles.button} ${className} ${
    disabled ? styles.disabled : ''
  }`;
  const renderColor = () => {
    if (transparent) {
      if (isHover) {
        return '#FFFFFF';
      } else {
        return variant ? variant : page_ButtonColor;
      }
    } else if (opicBackground) {
      if (isHover) {
        return '#FFFFFF';
      } else {
        return variant ? variant : page_ButtonColor;
      }
    } else {
      if (isHover) {
        return variant ? variant : page_ButtonColor;
      } else {
        return '#FFFFFF';
      }
    }
  };
  const renderBackgroundColor = () => {
    if (transparent) {
      if (isHover) {
        return `${variant ? variant : page_ButtonColor}`;
      } else {
        return 'transparent';
      }
    } else if (opicBackground) {
      if (isHover) {
        return `${variant ? variant : page_ButtonColor}`;
      } else {
        return addOpacityToColor(variant ? variant : page_ButtonColor);
      }
    } else {
      if (isHover) {
        return addOpacityToColor(variant ? variant : page_ButtonColor);
      } else {
        return `${variant ? variant : page_ButtonColor}`;
      }
    }
  };

  const renderBorder = () => {
    if (transparent) {
      return `0.2px solid ${variant ? variant : page_ButtonColor}`;
    }
  };

  const customizedStyle = {
    width: width,
    color: renderColor(),
    backgroundColor: renderBackgroundColor(),
    border: renderBorder(),
  };

  const Icon = getSvg(type, `${styles['image']} ${svgClassName || ''}`);
  return (
    <button
      className={buttonClass}
      onClick={onClick}
      style={customizedStyle}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      type={buttonType ?? 'button'}
      disabled={isLoading || disabled}
      id={id}
      {...props}
    >
      {isLoading ? (
        <Loader isComponent style={{ width: '20px', height: '21px' }} />
      ) : (
        <>
          {type ? (
            <span className={styles['text-container']}>
              <Icon color={renderColor()} className={styles.icon} />
            </span>
          ) : null}
          {label ? <p className={labelClassName}> {label}</p> : null}
        </>
      )}
    </button>
  );
};

export default Button;
